// src/parseClient.js
import Parse from 'parse';

// IMPORTANT: Initialize Parse with Back4App keys
// Using JavaScript Key for web/JavaScript code
const JAVASCRIPT_KEY = "X5K40fnfYy6HrKclm4ayKa7PSzKz6MPgw7b0YAfi";
const APP_ID = "lbHRArcsUTmtkoev9i2LBYdnGxGSVJOqbKQY6YfL";

try {
  Parse.initialize(APP_ID, JAVASCRIPT_KEY);
  Parse.serverURL = "https://parseapi.back4app.com";
  console.log('[ParseClient] ✅ Parse initialized with JavaScript Key');
  console.log('[ParseClient] App ID:', APP_ID);
  console.log('[ParseClient] Server URL:', Parse.serverURL);
  console.log('[ParseClient] Current Parse key (first 10 chars):', JAVASCRIPT_KEY.substring(0, 10) + '...');
} catch (error) {
  console.error('[ParseClient] ❌ Failed to initialize Parse:', error);
}

// Fallback: Also check window.Parse in case it was loaded via script tag (for native apps)
// This is useful for native apps that might load parse.min.js via script tag
const ParseClient = Parse || window.Parse;

if (!ParseClient) {
  console.error("ParseClient is undefined. Parse SDK failed to load.");
}

// Add logging wrapper for Parse User save() to track when users are saved
// This helps debug why updatedAt might change when user just opens the app
if (ParseClient && ParseClient.User) {
  const originalSave = ParseClient.User.prototype.save;
  ParseClient.User.prototype.save = function(...args) {
    const userId = this.id || 'unknown';
    const username = this.get ? this.get('username') : 'unknown';
    const dirtyKeys = this.dirtyKeys ? this.dirtyKeys() : [];
    
    // Get stack trace to see where save is called from
    const stack = new Error().stack;
    const caller = stack.split('\n')[2]?.trim() || 'unknown';
    
    console.log('[User Save] User.save() called:', {
      userId,
      username,
      dirtyKeys,
      hasDirtyKeys: dirtyKeys.length > 0,
      caller,
      timestamp: new Date().toISOString()
    });
    
    // Call original save method
    return originalSave.apply(this, args);
  };
}

export default ParseClient;